var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddInjuryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.756,
    height: 16.069,
    viewBox: "0 0 18.756 16.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#78849e;stroke-miterlimit:10;stroke-width:0.977px;}.b{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1018.511 -594.512)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M554.3,726.024a1.2,1.2,0,0,1-1.2,1.2H540.223a1.2,1.2,0,0,1-1.2-1.2v-10.2a1.2,1.2,0,0,1,1.2-1.2H553.1a1.2,1.2,0,0,1,1.2,1.2Zm1.31-1.309a1.2,1.2,0,0,0,1.2-1.2v-10.2a1.2,1.2,0,0,0-1.2-1.2H542.729a1.2,1.2,0,0,0-1.2,1.2",
    transform: "translate(479.973 -117.127)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1027.389 603.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M190.4,4.6l-.266.269a1.213,1.213,0,0,1-1.726-.034,1.237,1.237,0,0,1-.341-.842,1.194,1.194,0,0,1,.346-.86l.267-.269-.267-.269a1.234,1.234,0,0,1,.045-1.724l.01-.009h0a1.208,1.208,0,0,1,1.664,0l.267.269.317-.32a1.209,1.209,0,0,1,1.719.051h0a1.235,1.235,0,0,1,0,1.684l-.317.32.267.269a1.234,1.234,0,0,1,.043,1.724l-.009.009h0a1.208,1.208,0,0,1-1.718.034h0l-.033-.033ZM188.8,4.487a.684.684,0,0,0,.973.014h0l.267-.269-.987-.995-.267.269a.7.7,0,0,0,.009.976l0,0Zm3.262-3.292a.7.7,0,0,0-.5-.209.663.663,0,0,0-.474.2l-.317.32.986.995.317-.32a.7.7,0,0,0-.007-.977l0,0Zm-.035,3.3a.709.709,0,0,0,0-.991l0,0-2.257-2.274a.693.693,0,0,0-.986,0h0a.708.708,0,0,0,0,.99l0,0h0L191.04,4.5a.693.693,0,0,0,.986,0Z",
    transform: "translate(-188.071 -0.477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInjuryIcon);
export default __webpack_public_path__ + "static/media/add_injury_icon.97224f7c7528fb0c15d4825319d77a6e.svg";
export { ForwardRef as ReactComponent };